interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: "center" | "left";
  light?: boolean;
}

export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = "center",
  light = false,
}: SectionHeadingProps) {
  const alignment = align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <div className={`flex flex-col ${alignment}`}>
      {eyebrow && (
        <span
          className={`mb-3 inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-widest ${
            light ? "bg-white/10 text-primary-200" : "bg-primary-100 text-primary-700"
          }`}
        >
          <i className="ri-map-pin-2-fill" />
          {eyebrow}
        </span>
      )}
      <h2
        className={`max-w-3xl font-heading text-2xl font-bold leading-snug md:text-4xl ${
          light ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-4 max-w-2xl text-sm leading-relaxed md:text-base ${light ? "text-background-200" : "text-foreground-600"}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}